// Copyright ©️ 2026 eVolve MEP, LLC

import {
  BendPreviewGeometry,
  type BendPreviewSpecifications,
} from 'modules/Shop/EvolveFabrication/BendCreator/BendPreview/BendPreviewGeometry';

export class Offset90BackToBackGeometry extends BendPreviewGeometry {
  getDefaultDimensions() {
    const baseDims = super.getDefaultDimensions();
    // Take up length is derived from tail length and nose length.
    // Both measurements overlap, since they measure to opposite sides of the conduit. So the overlap is `conduitSize`.
    return { ...baseDims, takeUpLength: baseDims.tailLength + baseDims.noseLength - baseDims.conduitSize };
  }
  createBendDefs(dimensions: BendPreviewSpecifications) {
    const { tailLength, takeUpLength, offsetHeight, noseLength } = dimensions;

    return [
      {
        runLength: tailLength,
        endMeasuredTo: 'tubeEdge',
        thenBendBy: Math.PI / 2,
        startLabels: [
          {
            label: 'Tail Length',
            length: tailLength,
            offsets: [{ relativeTo: 'world', offset: 'down' }],
          },
          {
            label: 'Take Up Length',
            length: takeUpLength,
            preferredDistance: 0.2,
            offsets: [{ relativeTo: 'world', offset: 'down' }],
          },
        ],
      },
      {
        runLength: offsetHeight,
        thenRotateBy: Math.PI,
        thenBendBy: Math.PI / 2,
        startLabels: [
          {
            label: 'Offset Height',
            length: offsetHeight,
            canPlaceInsideGeometry: true,
            directionPreference: 'inward',
            preferredDistance: 0.3,
            offsets: [
              { relativeTo: 'bendPlane', offset: 'backward' },
              { relativeTo: 'bendPlane', offset: 'top' },
            ],
          },
        ],
      },
      {
        runLength: noseLength,
        startMeasuredFrom: 'tubeEdge',
        startLabels: [
          {
            label: 'Nose Length',
            length: noseLength,
            offsets: [
              { relativeTo: 'bendPlane', offset: 'backward' },
              { relativeTo: 'world', offset: 'down' },
            ],
          },
        ],
      },
    ] as const;
  }
}
